module.exports = __webpack_public_path__ + "static/media/merklingen3.fa06bc90.jpg";